import { Token } from '@ui/config/token/types';
import { Fraction } from 'bi-fraction';

import type { TokenOption, TokenPriceFetcher } from '../types';

export const stableTokenFetcher: TokenPriceFetcher = {
  fetchPrice: async (token: TokenOption) => {
    if (token !== Token.vUSD) throw new Error('Unsupported token');
    return {
      usd_price: new Fraction(1),
      usd_price_change_24h: new Fraction(0),
    };
  },
  supportsToken: (token: TokenOption) => token === Token.vUSD,
};
